/**
 * The React Flow root's classes while the canvas pans (the Hand tool, or Space
 * held). Everything inside the viewport — nodes, edges, edge labels and the
 * viewport portal — stops taking the pointer, so a press anywhere on the graph
 * lands on the pane and pans. HUD controls, the mini-map and portalled menus sit
 * outside the viewport and stay live.
 *
 * `!important` on EVERY descendant is the whole rule, not a node-level one: a
 * node's own `draggable: true` outranks the canvas's `nodesDraggable={false}`,
 * and a child that sets `pointer-events: auto` (or carries `nopan`) escapes an
 * inherited `none` — so a VSM shape would still move and the timeline ladder
 * would still refuse the pan.
 *
 * Tailwind v4 turns `_` into a space inside an arbitrary variant, so a React
 * Flow class's `__` must be written `\_\_`, and `String.raw` keeps the
 * backslashes. Unescaped, `[&_.react-flow__node]` compiled to
 * `.react-flow node` and matched nothing. `canvas-pan-classes.test.ts` compiles
 * this string to pin the selectors.
 */
export const CANVAS_PAN_CLASSES = String.raw`[&_.react-flow\_\_viewport_*]:!pointer-events-none [&_.react-flow\_\_pane]:!cursor-grab [&_.react-flow\_\_pane:active]:!cursor-grabbing`;
